// Position Choices for Players
export const PLAYER_POSITIONS = [
    { value: 'goal_keeper', label: 'Goalkeeper' },
    { value: 'center_back', label: 'Center-Back' },
    { value: 'left_back', label: 'Left-Back' },
    { value: 'right_back', label: 'Right-Back' },
    { value: 'center_midfielder', label: 'Center-Midfielder' },
    { value: 'defensive_midfielder', label: 'Defensive-Midfielder' },
    { value: 'attacking_midfielder', label: 'Attacking-Midfielder' },
    { value: 'left_winger', label: 'Left Winger' },
    { value: 'right_winger', label: 'Right Winger' },
    { value: 'center_forward', label: 'Center Forward' }
];

export const COACH_POSITIONS = [
    { value: 'head_coach', label: 'Head Coach' },
    { value: 'assistant_coach', label: 'Assistant Coach' },
    { value: 'goalkeeping_coach', label: 'Goalkeeping Coach' },
    { value: 'strength_and_conditioning_coach', label: 'Strength and Conditioning Coach' },
    { value: 'youth_coach', label: 'Youth Coach' }
];

export const STAFF_POSITIONS = [
    { value: 'technical_director', label: 'Technical Director' },
    { value: 'sporting_director', label: 'Sporting Director' },
    { value: 'team_manager', label: 'Team Manager' },
    { value: 'scout', label: 'Scout' },
    { value: 'head_of_scouting', label: 'Head of Scouting' },
    { value: 'physiotherapist', label: 'Physiotherapist' },
    { value: 'sports_doctor', label: 'Sports Doctor' },
    { value: 'nutritionist', label: 'Nutritionist' },
    { value: 'sports_psychologist', label: 'Sports Psychologist' },
    { value: 'performance_analyst', label: 'Performance Analyst' },
    { value: 'youth_coordinator', label: 'Youth Coordinator' },
    { value: 'medical_staff', label: 'Medical Staff' },
    { value: 'academy_director', label: 'Academy Director' },
    { value: 'youth_scout', label: 'Youth Scout' }
];


// Experience Choices
export const EXPERIENCE_CHOICES = [
    { value: '2-3', label: '2-3 years' },
    { value: '3-5', label: '3-5 years' },
    { value: '5-7', label: '5-7 years' },
    { value: '7-10', label: '7-10 years' }
];

// Age Choices
export const AGE_CHOICES = [
    { value: '12-18', label: '12 - 18 years' },
    { value: '18-24', label: '18 - 24 years' },
    { value: '24-32', label: '24 - 32 years' },
    { value: '32-40', label: '32 - 40 years' }
];

// Recruiting For Choices
export const RECRUITING_FOR_CHOICES = [
    { value: 'professional', label: 'Professional' },
    { value: 'youth', label: 'Youth' }
];

// Type of Tender Choices
export const TYPE_OF_TENDER_CHOICES = [
    { value: 'buy', label: 'Buy' },
    { value: 'loan', label: 'Loan' },
    { value: 'trial', label: 'Trial' }
];

// Staff Tender Type Choices
export const STAFF_TENDER_TYPE_CHOICES = [
    { value: 'full_time', label: 'Full Time' },
    { value: 'contract', label: 'Contract' },
    { value: 'temporary', label: 'Temporary' }
];

// Salary Type Choices
export const SALARY_TYPE_CHOICES = [
    { value: 'salary_between', label: 'Salary between' },
    { value: 'fixed_amount', label: 'Fixed Amount' }
];

// Currency Choices.
//
// The platform's main currency catalog: club requests (TenderFormDetails),
// agent requests (AgentTenderForm, via constants/agentTenderChoices), pitches
// to an agent request (PitchToAgentTender) and search requests
// (CreateSearchRequest) all read THIS array.
//
// CHF joins them (Marin, 2026-08-02: "CHF plattformweit rein danke") — the
// follow-up to putting it on the pitch transfer fee (#238/#288). It is last
// here for the same reason the other three are in this order: nothing
// pre-selects by position, every consumer sets its own default explicitly
// (EUR everywhere — see e.g. CreateTender.js, DECISION-010), and appending
// leaves the existing three where users are used to finding them.
//
// AgentTenderForm re-sorts this list through its own CURRENCY_ORDER
// (EUR · GBP · CHF · USD) before rendering; that map already had CHF in it
// and only ever lacked the entry to sort. Its "EUR · GBP · CHF · USD" hint
// now describes what the dropdown actually offers.
//
// The labels are one word, matching the backend's Pitch choices
// (Euro / Dollar / Pound / Franc).
export const CURRENCY_CHOICES = [
    { value: 'USD', label: 'Dollar' },
    { value: 'EUR', label: 'Euro' },
    { value: 'GBP', label: 'Pound' },
    { value: 'CHF', label: 'Franc' }
];

// Foot Choices (for players only)
export const FOOT_CHOICES = [
    { value: 'R', label: 'Right' },
    { value: 'L', label: 'Left' },
    { value: 'A', label: 'Any' }
];

// Height Choices (for players only)
export const HEIGHT_CHOICES = [
    { value: 170, label: '170 cm' },
    { value: 200, label: '200 cm' },
    { value: 230, label: '230 cm' },
    { value: 250, label: '250 cm' },
    { value: 280, label: '280 cm' }
];

// Market Value Type Choices (for players only)
export const MARKET_VALUE_CHOICES = [
    { value: 'market_value_range', label: 'Market value between' },
    { value: 'market_value_fixed', label: 'Fixed Amount' },
    { value: 'not_important', label: 'Not important' }
];

// Tender Category Choices
export const TENDER_CATEGORY_CHOICES = [
    { value: 'player', label: 'Player' },
    { value: 'staff', label: 'Staff' }
];

// Games Played Choices
export const GAMES_PLAYED_CHOICES = [
    { value: 'last_season', label: 'Last season' },
    { value: 'last_half_season', label: 'Last half season' },
    { value: 'not_important', label: 'Not important' }
];

// Language Choices
export const LANGUAGE_CHOICES = [
    { value: 'English', label: 'English' },
    { value: 'Spanish', label: 'Spanish' },
    { value: 'French', label: 'French' },
    { value: 'German', label: 'German' },
    { value: 'Italian', label: 'Italian' },
    { value: 'Portuguese', label: 'Portuguese' },
    { value: 'Dutch', label: 'Dutch' },
    { value: 'Russian', label: 'Russian' },
    { value: 'Arabic', label: 'Arabic' },
    { value: 'Chinese', label: 'Chinese' },
    { value: 'Japanese', label: 'Japanese' },
    { value: 'Korean', label: 'Korean' }
]; 